import './App.css';
import './Grid.css';
import Intro from './Intro';
import PlayerSearch from './PlayerSearch'

function App() {
  return (
<>
        <PlayerSearch />
</>
  );
}

export default App;
